<template>
<div>
    <b-modal v-model="showModal" :hide-footer="true" :hide-header="true" centered id="message-modal" ref="message-modal" title="Message" size="sm" :no-close-on-backdrop="true">
        <b-row>
            <b-col class="text-left" cols="12" v-if="message" v-html="text"></b-col>
        </b-row>
        <b-row :class="modalClasses">
            <b-col cols="12">
              <div class="text-center pt-5 secondary-btn-container" v-if="messageAdditional">
                <button @click="handleAdditional">{{ messageAdditional.title | lang }}</button>
              </div>
              <div class="text-center primary-btn-container" :class="messageAdditional ? 'pt-2' : 'pt-5'">
                  <button @click="handleClose">{{ 'ok' | lang }}</button>
              </div>
            </b-col>
        </b-row>
    </b-modal>
</div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import lang from '@sl/base/filters/lang';

export default {
    data() {
        return { showModal: false };
    },
    methods: {
        ...mapMutations(['setMessage', 'setAfterMessage', 'setMessageAdditional']),
        handleClose() {
            this.$root.$emit('bv::hide::modal', 'message-modal');

            if (this.afterMessage) {
                this.afterMessage();
            }

            this.setMessage('');
            this.setMessageAdditional(undefined);
            this.setAfterMessage(undefined);
        },
        handleAdditional() {
          this.$root.$emit('bv::hide::modal', 'message-modal');

          this.messageAdditional.callback();

          this.setMessage('');
          this.setMessageAdditional(undefined);
          this.setAfterMessage(undefined);
        },
    },
    computed: {
        ...mapState(['message', 'messageAdditional', 'afterMessage']),

      text() {
          return lang(this.message);
      },

      modalClasses() {
        if (this.messageAdditional && this.messageAdditional.type) {
          return [`message-type-${this.messageAdditional.type}`];
        }
      },
    },

    watch: {
        message(value) {
            this.showModal = !!value;
        },
    },

    created() {
        this.showModal = !!this.message;
    },
}
</script>